module.exports = __webpack_public_path__ + "img/xiao6.398fb4a1.png";